/**
 * Per-pair trading metadata served by `GET v1/hub/paper-trading/pair-metas`.
 * Mirrors the Redis pair-meta cache the paper order validator reads, so the
 * FE leverage cap / size precision can never drift from what the backend
 * enforces. `maxLeverage` is the EFFECTIVE cap (synthetic floor applied by
 * the publisher), not Hyperliquid's raw per-asset cap.
 */
export type PaperPairTradingMetaDto = {
  /** Clean CCXT pair symbol, e.g. `"BTC/USDC:USDC"`. */
  pairSymbol: string;
  /** Number of decimals allowed on order size. */
  szDecimals: number;
  /** Effective max leverage (integer, synthetic floor applied). */
  maxLeverage: number;
  /** Minimum order notional in USD. */
  minNotionalUsd: number;
  /** Price tick size as a decimal string. */
  tickSize: string;
};

export type PaperPairMetasResponse = {
  pairs: PaperPairTradingMetaDto[];
};
